import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { config } from '../../../../../config/config';
import { CreatePlaceCommand } from '../../../../commands/hub/place/create.place.command';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { CanComponentDeactivate } from '../../../../common/guards/index';
import { ModalService } from '../../../../common/services/modal.service';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { AlertifyService } from '../../../../services/alertify.service';
import { HubApiService } from '../../../../services/hub.api.service';
import { ImageService } from '../../../../services/image.service';
import { ToggleStore } from '../../../../stores/hub.calendar.store';
import { HubComponent } from '../../hub.component';
import { HubVisitorDataSource } from '../../../../models/hub/hub.visitor.data.source';
import { EditPlaceCategoryModalActions } from '../../edit.place.category.modal/edit.place.category.modal.provider';
import { EditPlaceCategoryModalComponent } from '../../edit.place.category.modal/edit.place.category.modal.component';
import { HubPlace } from '../../../../models/hub/hub.place';
import { PlaceService } from '../../../../services/place.service';

@Component({
  selector: 'ig-hub-create-place',
  templateUrl: './create.place.component.html',
  styleUrls: ['./create.place.component.scss'],
})
export class CreatePlaceComponent extends BaseComponent implements OnInit, CanComponentDeactivate {
  public hubName: string;
  public selectedImageData: string;
  public command = new CreatePlaceCommand();
  public categoryText = '';
  public resizeImageTemp = null;
  public createPlaceForm: FormGroup;
  public toggles = new HubVisitorFeatureToggle();
  public placeSource = null;
  public isImageChanged = false;
  public hasCopyrights = false;
  public imageUploaderLabel2 = 'Please upload images in JPG, PNG or WEBP format. Landscape images recommended';
  @ViewChild('description') public descriptionArea: ElementRef;
  @ViewChild('form') public form: Form;
  @ViewChild('createPlaceSuccess') public successWrap: SuccessWrapComponent;
  public placeCategorySourceItems = [];

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private modalService: ModalService,
    private imageService: ImageService,
    private parent: HubComponent,
    private alertify: AlertifyService,
    private togglesStore: ToggleStore,
    private hubApiService: HubApiService
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;
    this.command.defaultImage = config.defaultImageUrl;
    this.createPlaceForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      description: [null, []],
      address: [null, [Validators.required]],
      website: [null, []],
      category: [null, []],
    });

    // this.hubApiService.getPlaceCategoryToggle(this.hubName).subscribe(toggleCommand => {
    //     this.toggles = toggleCommand.toggle;
    //     this.placeSource = toggleCommand.dataSource;
    //     if (this.placeSource.businessType === 'area business') {
    //         this.placeCategorySourceItems = [
    //             {
    //                 text: 'Beauty',
    //                 value: 'Beauty'
    //             }, {
    //                 text: 'Cars & Motor Services',
    //                 value: 'Cars & Motor Services'
    //             }, {
    //                 text: 'Cleaning Services',
    //                 value: 'Cleaning Services'
    //             }, {
    //                 text: 'Convenience & Pharmacies',
    //                 value: 'Convenience & Pharmacies'
    //             }, {
    //                 text: 'Pet Services',
    //                 value: 'Pet Services'
    //             }
    //         ];
    //         return;
    //     }
    //     if (this.placeSource.businessType === 'local secrets') {
    //         this.placeCategorySourceItems = [
    //             {
    //                 text: 'Art and Culture',
    //                 value: 'Art and Culture'
    //             }, {
    //                 text: 'Food and Drink',
    //                 value: 'Food and Drink'
    //             }, {
    //                 text: 'Nightlife',
    //                 value: 'Nightlife'
    //             }, {
    //                 text: 'Trip & Tours Planner',
    //                 value: 'Trip & Tours Planner'
    //             }, {
    //                 text: 'Local Rental Services',
    //                 value: 'Local Rental Services'
    //             }, {
    //                 text: 'Health & Personal Care',
    //                 value: 'Health & Personal Care'
    //             }, {
    //                 text: 'Accommodations',
    //                 value: 'Accommodations'
    //             }, {
    //                 text: 'Sports & Leisure',
    //                 value: 'Sports & Leisure'
    //             }, {
    //                 text: 'Shopping',
    //                 value: 'Shopping'
    //             }
    //         ];
    //         return;
    //     }
    //
    //     if (this.toggles.placeCategory.thingsToDo) {
    //         this.placeCategorySourceItems = [
    //             {
    //                 text: 'Accommodations',
    //                 value: 'Accommodations',
    //                 hide: !this.toggles.placeCategory.accommodation
    //             }, {
    //                 text: 'Dining & Nightlife',
    //                 value: 'Dining & Nightlife',
    //                 hide: !this.toggles.placeCategory.dining
    //             }, {
    //                 text: 'Shopping',
    //                 value: 'Shopping',
    //                 hide: !this.toggles.placeCategory.shopping
    //             }, {
    //                 text: 'Things to Do',
    //                 value: 'Things to Do',
    //             }, {
    //                 text: 'Travel',
    //                 value: 'Travel',
    //                 hide: !this.toggles.placeCategory.travel
    //             }, {
    //                 text: 'Other',
    //                 value: 'Other',
    //                 hide: !this.toggles.placeCategory.other
    //             }];
    //         return;
    //     }
    //
    //     this.placeCategorySourceItems = [
    //         {
    //             text: 'Accommodations',
    //             value: 'Accommodations',
    //             hide: !this.toggles.placeCategory.accommodation
    //         }, {
    //             text: 'Activities',
    //             value: 'Activities',
    //             hide: this.placeSource.place !== 'google' || !this.toggles.placeCategory.activity
    //         }, {
    //             text: 'Arts & Culture',
    //             value: 'Arts & Culture',
    //             hide: this.placeSource.place !== 'google' || !this.toggles.placeCategory.art
    //         }, {
    //             text: 'Outdoors & Fitness',
    //             value: 'Outdoors & Fitness',
    //             hide: this.placeSource.place !== 'google' || !this.toggles.placeCategory.outdoor
    //         }, {
    //             text: 'Entertainment',
    //             value: 'Entertainment',
    //             hide: this.placeSource.place !== 'google' || !this.toggles.placeCategory.entertainment
    //         }, {
    //             text: 'Dining & Nightlife',
    //             value: 'Dining & Nightlife',
    //             hide: !this.toggles.placeCategory.dining
    //         }, {
    //             text: 'Shopping',
    //             value: 'Shopping',
    //             hide: !this.toggles.placeCategory.shopping
    //         }, {
    //             text: 'Travel',
    //             value: 'Travel',
    //             hide: !this.toggles.placeCategory.travel
    //         }, {
    //             text: 'Other',
    //             value: 'Other',
    //             hide: !this.toggles.placeCategory.other
    //         }];
    // });
  }

  public showEditCategoryModal() {
    let actions = <EditPlaceCategoryModalActions>{
      confirm: (event: ButtonTriggerEvent, category) => {
        this.categoryText = category.categoryText;
        this.command.category = category.category;
      },
    };

    this.modalService.show({
      component: EditPlaceCategoryModalComponent,
      providers: [
        { provide: EditPlaceCategoryModalActions, useValue: actions },
        {
          provide: HubPlace,
          useValue: {
            hubName: this.hubName,
            categoryText: this.categoryText,
            category: this.command.category,
            categoryList: this.command.category ? this.command.category.split(', ') : [],
          } as HubPlace,
        },
      ],
      panelClass: 'width-modal-70p',
    });
  }

  public categorySourceChange(target) {
    this.command.category = target.value;
  }

  public async onImageChange(file) {
    if (file) {
      this.resizeImageTemp = await this.imageService.compressImageFileToBase64(file, config.compressImgWidth);
    }
  }

  public async createPlace(event: ButtonTriggerEvent) {
    let { hubName } = this.allRouteParams;
    this.command.isHubCreated = true;

    // if (this.command.image) {
    // 	this.command.image = await this.imageService.compressImageFile(this.command.image);
    // }

    // image uploaded
    if (this.resizeImageTemp) {
      const res = await this.hubApiService.uploadBase64ImageToAWS(this.resizeImageTemp);
      if (res.success) {
        this.command.image = null;
        this.command.imageLink = res.url;
      }
    }

    this.hubApiService
      .createPlace(hubName, this.command)
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Create place');
        this.command = new CreatePlaceCommand();
        // this.command.category = 'Activities';
        this.createPlaceForm.markAsPristine();
        this.selectedImageData = null;
        this.categoryText = '';
        this.descriptionArea.nativeElement.style.height = '40px';
        this.resizeImageTemp = null;
      });
  }

  public descriptionChange() {
    this.descriptionArea.nativeElement.style.height =
      Math.min(this.descriptionArea.nativeElement.scrollHeight, 500) + 'px';
  }

  public canDeactivate() {
    if (this.createPlaceForm.pristine) {
      return Observable.of(true);
    }

    let allowNavigate = new Subject<boolean>();

    this.modalService.showUnSaveWarning({ allowNavigate });

    return allowNavigate;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/manually.add/create.place/create.place.component.ts